module.exports = __webpack_public_path__ + "static/img/LifeatDito1b.393d1fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hr/LifeatDito1b.png
// module id = bHnH
// module chunks = 2